import './App.css';

function App() {
  return (
    <main className="parked-site">
      <section className="parked-site__message" aria-labelledby="page-title">
        <p className="parked-site__label">Website notice</p>
        <h1 id="page-title">Site under progress</h1>
        <p>This website is currently parked. No healthcare services are being offered through this site.</p>
      </section>
    </main>
  );
}

export default App;
